import React from 'react';
import {
  TableRow,
  TableCell,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox
} from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import DeleteIcon from '@mui/icons-material/Delete';
import { customComponentMap, customComponentSettings } from './assetListCustomComponents.js';
import moment from 'moment';

function AssetListItemCreate({ rowData, index, columns, onChange, onDelete, productId }) {
  const [vehicleModelData, setVehicleModelData] = React.useState([]);
  const [vehicleVariantData, setVehicleVariantData] = React.useState([]);
  const renderInput = (attr, head) => {
    const value = rowData[attr] || '';


    if (['dateOfManufacture', 'purchaseDate', 'installationDate'].includes(attr)) {
      return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            views={['year', 'month', 'day']}
            inputFormat="dd-MM-yyyy"
            value={rowData[attr] ? moment(rowData[attr], "DD-MM-YYYY").toDate() : null}
            onChange={(val) => {
              const formattedDate = val ? moment(val).format("DD-MM-YYYY") : null;
              onChange(attr, formattedDate);
            }}
            maxDate={new Date()}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                fullWidth
                style={{ minWidth: "180px" }}
              />
            )}
          />
        </LocalizationProvider>
      );
    }

    if (['wetRisk', 'hillyAreas', 'undergroundWork'].includes(attr)) {
      return (
        <FormControl fullWidth size="small">
          <InputLabel>{head.title || attr}</InputLabel>
          <Select
            label={head.title || attr}
            value={value}
            onChange={(e) => onChange(attr, e.target.value)}
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </Select>
        </FormControl>
      );
    }

    const CustomComponent = customComponentMap[attr];
    const CustomSetting = customComponentSettings[attr];


    if (CustomComponent && CustomSetting) {
      const commonProps = {
        tableListDatas: [rowData],
        index: 0,
        productId,
        label: head.title || head.sumInsuredHeader.title || attr,
        apiUrl: CustomSetting,
        handleChange: (attr, _, val) => onChange(attr, val),
        saveRow: () => { }
      };
      const extraProps =
        attr === 'vehicleModel' ? { vehicleModelData, setVehicleModelData, setVehicleVariantData } :
          attr === 'vehicleVariant' ? { vehicleModelData, vehicleVariantData, setVehicleVariantData } :
            attr === 'vehicleMake' ? { setVehicleModelData } :
              attr === 'occupancy' ? { productId } :
                {};

      return <CustomComponent {...commonProps} {...extraProps} />;

    }

    return (
      <TextField
        size="small"
        fullWidth
        value={value}
        onChange={(e) => onChange(attr, e.target.value)}
      />
    );
  };

  return (
    <TableRow>

      <TableCell padding="checkbox">
        <Checkbox checked={false} disabled />
      </TableCell>
      <TableCell>{index + 1}</TableCell>
      {columns.map(head => {
        const attr = head.sumInsuredHeader.attribute;
        return (
          <TableCell key={attr}>
            {renderInput(attr, head)}
          </TableCell>
        );
      })}
      <TableCell>
        <IconButton size="small" onClick={onDelete}>
          <DeleteIcon fontSize="small" color="error" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

export default AssetListItemCreate;
